// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__gScdM","options":"AnswerScale_options__3H-3A","selected":"AnswerScale_selected__vUtbw"};